import { InsightErrorFlags, InsightErrorType, InsightInfo, Proposition } from '../../../shared/types';

export const mapPropositionToSlug = (proposition: Proposition): string => {
  switch (proposition) {
    case Proposition.Consumer:
      return 'consumerIntelligence';
    case Proposition.Retail:
      return 'retailIntelligence';
    case Proposition.Market:
      return 'mi';
    case Proposition.DistributionPanel:
      return 'dpi';
    case Proposition.Link:
      return 'Link Intelligence';
    case Proposition.Playground:
      return 'Playground Intelligence';
    default:
      return proposition;
  }
};

export const getErrorFlags = (errorType?: InsightErrorType): InsightErrorFlags => {
  const isInsightError = !!errorType;

  return {
    isInsightError,
    isSubscriptionError: errorType === InsightErrorType.SUBSCRIPTION_ERROR,
    isExpirationError: errorType === InsightErrorType.EXPIRED,
    isMultiConfigError: errorType === InsightErrorType.MULTI_CONFIG_ERROR,
    isOtherRenderError:
      isInsightError &&
      ![
        InsightErrorType.SUBSCRIPTION_ERROR,
        InsightErrorType.EXPIRED,
        InsightErrorType.MULTI_CONFIG_ERROR,
        InsightErrorType.DATA_NOT_AVAILABLE,
      ].includes(errorType),
  };
};

export const getEditingStyles = (isBeingEdited: boolean, editingInsightId: string | undefined): string =>
  editingInsightId ? (isBeingEdited ? 'rounded-insight border-brand' : 'low-lighted') : '';

export const getActionStyles = (isBeingEdited: boolean): string => (isBeingEdited ? 'low-lighted' : '');

export const getInsightRendererStyles = (infoOrInsightLoading: boolean): React.CSSProperties =>
  infoOrInsightLoading ? { display: 'none' } : { containerType: 'inline-size' };

export const getInsightRendererClassName = (infoOrInsightLoading: boolean, isInsightError: boolean): string =>
  `${!infoOrInsightLoading && !isInsightError ? 'border-b border-default' : ''}`;

export const getInsightInfoStyles = (insightInfo: InsightInfo | undefined): string =>
  insightInfo?.tags?.length > 0 ? 'justify-between' : 'justify-end';

export const getPadding = (addPadding: boolean): React.CSSProperties => (addPadding ? { paddingBottom: '400px' } : {});
